<template lang="pug">
div
    v-responsive.player(:aspect-ratio="16 / 9")
        .ratioContainer
            .canvas(ref="canvasBox")
                slot(name="videoSlot")
                div(v-if="video.id == 'intro' || video.id == 'outro'")
                div(v-else-if="video.overlays && video.overlays.length > 0")
                    .overlays(:style="{  width: windowSize.width + 'px', height: windowSize.height + 'px' }")
                        OverlayPreview(v-for="(overlay, index) in video.overlays" :overlay="overlay" :windowSize="windowSize" :key="index")

</template>

<script>
import urlFormat from "@/utils/urlFormat";
import OverlayPreview from "@/components/create/OverlayPreview";
export default {
  name: "OverlaysPreview",
  data() {
    return {
      windowSize: {
        height: 0,
        width: 0,
      },
    };
  },
  components: {
    OverlayPreview,
  },
  props: ["video"],
  watch: {
    $props: {
      handler() {
        this.matchHeight();
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.matchHeight();
    window.addEventListener("resize", this.matchHeight);
  },
  destroyed() {
    window.removeEventListener("resize", this.matchHeight);
  },
  mounted() {
    setTimeout(() => this.matchHeight());
  },
  computed: {},
  methods: {
    ...urlFormat,

    matchHeight() {
      const canvasBox = this.$refs.canvasBox;
      // console.log({ canvasBox });
      if (!canvasBox) return;

      const width = canvasBox.clientWidth;
      const height = canvasBox.clientHeight;
      // console.log({ canvasBox, height, width });
      this.windowSize.height = height;
      this.windowSize.width = width;
      // this.setSrcOfIframe();
    },
  },
};
</script>
<style lang="sass" scoped>
@import '@/assets/style/variables'
.ratioContainer
    height: 100% !important
    width: 100% !important
.canvas
    height: 100% !important
    width: 100% !important
.v-skeleton-loader
  border-radius: $radius
  // background: #000
  width: 100%
  height: 100% !important
  .v-skeleton-loader__image
    height: 100% !important
.player
  width: 100%
  border-radius: 10px
  background: transparent
  box-shadow: $box-shadow
  .imageOverlay
    position: absolute
    top: 0px
    left: 0px
    right: 0px
    bottom: 0px
    width: 100%
  .playOverlay
    position: absolute
    top: 0px
    left: 0px
    right: 0px
    bottom: 0px
    width: 100%
    height: 100%
    display: flex
    justify-content: center
    align-items: center
  .videoPlayer
    box-shadow: none
    border-radius: 10px
    overflow: visible
    width: 100%
    min-height: 100%
    .video-js
        min-height: 100%
    // background: $primary
.video-title
  color: var(--v-primary-lighten2)




.overlays
    position: absolute
    top: 0
    bottom: 0
    display: flex
    justify-content: flex-start
    align-items: flex-end

.imageOverlay
    position: absolute
    top: 0
    bottom: 0
    left: 0
    right: 0
.scaleIframe
    width: 1920px
    height: 1080px
    transition: all 0.3 ease
    transform-origin: left bottom
    -webkit-transform-origin: left bottom
    -moz-transform-origin: left bottom
</style>
